<template>
    <div class="m-8 p-2">
        <div class="mb-10 px-6 bg-gray-500">
            <h1>Privacy Statement</h1>
        </div>
        <h2>Google</h2>
        <p>
            At the time being this page uses Google Services as followed:
        </p>
        <ul class="list-disc pl-5">
            <li>Firebase Firestore, a database</li>
            <li>Firebase Cloud Functions, a serverless backend</li>
            <li>Firebase Authentication, well, authentication</li>
            <li>Google Analytics</li>
            <li>Google Search Console</li>
        </ul>
        <br>
        <h2>Facebook</h2>
        <p>
            This page uses the Facebook Pixel.
        </p>
        <h2>Others</h2>
        <p>
            Also this page will be using Mailgun to send emails.
        </p>
        <p>
            Last updated: April 22, 2020.
        </p>
    </div>
</template>

<script>
export default {
    name: 'Privacy',
};
</script>

<style scoped>
p {
    margin-bottom: 1rem;
}
h2 {
    margin-top: 0.4rem;
    font-weight: 700;
    font-size: 1.5rem;
}

a {
    color: #3498db;
    font-weight: 600;
}
</style>
